import axios from "axios"

const fetchScripts = async () => {
  try {
    const response = await axios.post("https://wp.tigen.pl/graphql", {
      query: `query {
            opcje {
              acfOptions {
                customScripts {
                  type
                  settings {
                    uniqueName
                    noscript
                    postBody
                  }
                  data
                }
              }
            }
          }
        `,
    })

    const data = response.data

    return data.data.opcje.acfOptions.customScripts
  } catch (error) {
    console.log(error)

    return undefined
  }
}

export default fetchScripts
